import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";

import Buttons from "../components/Buttons";
import RequestMe_and_RequestsOther from "../components/RequestMe_and_RequestsOther";
import Suppliers from "../components/main/Suppliers";
import Organizations from "../components/main/Organizations";
import Projects from "../components/main/Projects";
import { Button, FontIcon } from "react-md";

import { getRequest } from "../actions/requestActions";
import {
  getProviders,
  getProjects,
  getOrganizations
} from "../actions/resourceActions";
import { getUser } from "../actions/userActions";
import Translate from "../Atollon/Translation";
import {TouchPageHeader, TouchPageHeader_and_content_spaceBetween} from "../AtollonTheme/ReactElements";

const Main = ({ history }) => {

    const Spacer = ({height}) => (
        <div style={{height: height || '90px'}} />
    );

  return (
    <div className="flex-col">

        <TouchPageHeader
            title={"Hlavní panel"}
            buttons={(
                <div>
                    <Button
                        flat
                        primary
                        label={Translate( 'request-new', "Nový požadavek" )}
                        type="submit"
                        className="btn btn-primary touchButton-1"
                        onClick={() => history.push("/request-new")}
                    >
                        {<FontIcon className="color-white">album</FontIcon>}
                    </Button>

                    <Button
                        flat
                        primary
                        label={Translate( 'project-new', "Nový projekt" )}
                        type="submit"
                        className="btn btn-primary touchButton-1"
                        onClick={() => history.push("/project-new")}
                    >
                        {<FontIcon className="color-white">album</FontIcon>}
                    </Button>

                </div>
            )}
        />
        <TouchPageHeader_and_content_spaceBetween heightPx={50}/>

      <Spacer height={"60px"} />

      <RequestMe_and_RequestsOther history={history} />

      <Spacer />

      <Suppliers history={history} />

      <Spacer />

      <Organizations history={history} />

      <Spacer />

      <Projects history={history} />
    </div>
  );
};

export default compose(
  connect(
    ({ app: { afterActivation } }) => ({
      afterActivation
    }),
    {
      getRequest,
      getProviders,
      getProjects,
      getOrganizations,
      getUser
    }
  ),
  lifecycle({
    async componentWillMount() {
      const {
        getRequest,
        getProviders,
        getProjects,
        getOrganizations,
        afterActivation,
        getUser
      } = this.props;

      if (afterActivation) {
        await getUser();
      }

      getRequest({
        includeCount: "true",
        limit: 5,
        side: "PENDING",
        status: "INITIAL,ACCEPTED,RESOLVING"
      });
      getRequest({
        includeCount: "true",
        limit: 5,
        side: "NOT_PENDING",
        status: "INITIAL,ACCEPTED,RESOLVING"
      });
      getProviders();
      getProjects();
      getOrganizations();
    }
  })
)(Main);



// WEBPACK FOOTER //
// ./src/pages/Main.js